import {Injectable} from '@angular/core';
import {CanLoad, Route, Router, UrlSegment} from '@angular/router';
import { UserService } from 'app/services/user.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanLoad {

    constructor(private router: Router, private userService: UserService) {
    }

    canLoad(route: Route, segments: UrlSegment[]): Promise<boolean> | boolean {
        return this.userService.hasSystemAccess() ? true :
            this.router.navigate(['401']).finally(() => false);
    }

}
